import React, {useState, useEffect} from 'react'
import { RiThunderstormsLine } from "@react-icons/all-files/ri/RiThunderstormsLine";
import { AiOutlineControl } from "@react-icons/all-files/ai/AiOutlineControl";
import { FiTruck } from "@react-icons/all-files/fi/FiTruck";
import { FiAlertTriangle } from "@react-icons/all-files/fi/FiAlertTriangle";
import { FaWarehouse } from '@react-icons/all-files/fa/FaWarehouse';
import Button from './Button';
import { helper } from '../utilities/helper';
const NoticeRow = ({product, addToCartItems, orlando, unifiedEligible = false}) => {
  let [sel, setSel] = useState()
  let [tabs, setTabs] = useState([])

  useEffect(() => {
    if(product) {
      let _tabs = []

      if(product.outdoor_rated) _tabs.unshift([ < RiThunderstormsLine key={0} />, 'Outdoor'])

      if(product.requires_tech) _tabs.unshift([ < AiOutlineControl key={0} />, 'Requires Operation'])
      if(product.allow_pickup && (!orlando || product.orlando)) _tabs.unshift([<FaWarehouse key={0} />, 'Warehouse Pickup'])
    if(!product.only_purchase) _tabs.unshift([ < FiTruck key={0} />, 'Delivery'])
      if(product.alert) _tabs.unshift([ < FiAlertTriangle key={0} />, 'Warning'])

      setTabs(_tabs)
      setSel(_tabs[0]?.[1])
    }

  }, [product])

  let content = {
    "Delivery" : <div className='noticeMod'>
    <div className="iconHead">
      < FiTruck />
      <span>{!product.allow_pickup ? 'Requires' :''} Delivery & Installation</span>
    </div>
    <div className="modText">
     { !product.allow_pickup ? 'This item requires delivery and installation, adding this item to your cart will automatically include delivery and installation for your entire order.': ''}
     {!product.allow_pickup && <><br/><br/></>}

      We offer full delivery, installation, breakdown and technical assistance 24 hours 7 days per week including holidays. We service all South Florida from Orlando to Key West. Our technicians will deliver the equipment at a time of your choice, install it according to your specifications and instruct you on how to use the equipment. Delivery and installation prices are calculated based on your location and delivery times, please click &quot;Schedule Delivery&quot; to get an exact price.
    </div>
    <div className="deliveryPrice">
        <div className='priceCo'>
            <span className='estimat'>Estimated {orlando ? 'Orange County' : 'Miami-Dade'}  delivery & installation cost:</span>
            <span className="price">{helper.formatPrice(product.price.rental * ((product?.difficulty / 10)) *1.35)}</span>
            </div>
            <Button onClick={() => addToCartItems(product, true)} className={`btn-4  highLight`}><FiTruck />{unifiedEligible ? 'Add with delivery & setup' : 'Schedule Delivery'}</Button>
          </div>

  </div>,
  'Requires Operation' :<div className='noticeMod'>
  <div className="iconHead">
    < AiOutlineControl />
    <span>Requires Operation</span>
  </div>
  <div className="modText">
  This item requires a technician to be present for the entire duration of the event, a technician fee will be automatically added to your order.
  </div>
</div>,
"Outdoor": <div className='noticeMod'>
<div className="iconHead">
  < RiThunderstormsLine />
  <span>Outdoor Rated</span>
</div>
<div className="modText">
This item is weather proof and can be used in outdoor setups without additional outdoor damage hold.
</div>
</div>,
"Warning" : <div className='noticeMod'>
<div className="iconHead">
  < FiAlertTriangle />
  <span>Important Information</span>
</div>
<div className="modText">
{product.alert}
</div>
</div>,
"Warehouse Pickup": <div className='noticeMod'>
<div className="iconHead">
  < FaWarehouse />
  <span>Warehouse Pickup</span>
</div>
<div className="modText">
We are located at {orlando ? '8600 Commodity Cir #152 Orlando, FL 32819' : '20227 NE 15th Ct, Miami FL 33179, on I-95 and Ives Dairy'}. To avoid waiting, place your order online so all your items are ready at the time of your arrival.

</div>
<div className='row'>
<div className="wareHours">
                <span className='head'>Warehouse Hours:</span>
                <ul className='hours'>
                  <li><span>Monday:</span><span> 9:00 AM - 5:00 PM</span></li>
                  <li><span>Tuesday:</span><span> 9:00 AM - 5:00 PM</span></li>
                  <li><span>Wednesday:</span> <span>9:00 AM - 5:00 PM</span></li>
                  <li><span>Thursday:</span><span> 9:00 AM - 5:00 PM</span></li>
                  <li><span>Friday:</span><span> 9:00 AM - 5:00 PM</span></li>
                  <li><span>Saturday:</span> <span>9:00 AM - 12:00 PM</span></li>
                  <li><span>Sunday:</span><span> 9:00 AM - 12:00 PM</span></li>
                </ul>
              </div>
              <iframe className='googleMap' title='Google Map' src={orlando?
                "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d56130.27280788302!2d-81.431191!3d28.445134!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77fb418c8417d%3A0xe3ee1bf6f1075aa!2sMiami%20Sound%20Rental!5e0!3m2!1sen!2sus!4v1731515480989!5m2!1sen!2sus"
                : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85279.76786666439!2d-80.18819877200482!3d25.972544745070756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x641f16c240d54da2!2sMiami%20Sound%20Rental!5e0!3m2!1sen!2sus!4v1656608031734!5m2!1sen!2sus" }loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

  </div>
</div>


  }

  console.log(tabs)

  return  <div className="notices" id='delivery'>
   {tabs?.length > 1 && <div className="noticeTabs">
      {tabs.map((tab, i) => <div key={i} className={`tab ${sel === tab[1]? 'sel':''}`} onClick={() => setSel(tab[1])}>
        {tab[0]}<span>{tab[1]}</span>

      </div>)}
    </div>}
    {content[sel]}
  </div>

}

export default NoticeRow
